import React, { useEffect, useState } from "react";
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

import { BASE_URL } from './apiConfig';
import './CommonCSS.css'

export default function EditProfilePage() {
    const [guipassword, setguipassword] = useState(null);
    const [showprogress, setshowprogress] = useState(false);
    const navigate = useNavigate();

    const loginData = JSON.parse(sessionStorage.getItem("loginData"));
    useEffect(()=>{
        setguipassword(loginData?.guipassword)
    },[]);

    const callAPI = async () => {
        try {
            setshowprogress(true);
            if (loginData?.guipassword === guipassword) {
                Swal.fire({
                    title: 'Error Occurred',
                    html: 'Since Old and New Password are Same, No need to Call API for Updating the GUI Password',
                    icon: 'error'
                });
            }

            else {
                const apiUrl = `${BASE_URL}/UpdateGUIPassword`;
                const response = await fetch(apiUrl, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                        guiuserid: loginData?.guiuserid,
                        guipassword: guipassword,
                    }),
                });

                if (response.ok) {
                    const re = await Swal.fire({
                        title: 'GUI Password Updated Successfully',
                        html: `Your GUI Password is Updated SuccessFully From ${loginData?.guipassword} to ${guipassword}`,
                        icon: 'success'
                    });

                    if(re.isConfirmed){
                        sessionStorage.setItem('loginData', null);
                        navigate('/login');
                    }


                }

                else {
                    const errorMessage = response.statusText;
                    const responseBody = await response.text();
                    setshowprogress(false);
                    const result = await Swal.fire({
                        title: 'GUI Password Update Error',
                        html: `${errorMessage}${responseBody}`,
                        icon: 'error'
                    });
                }

            }
        }

        catch (error) {
            console.error("API Request Error:", error.message);
            setshowprogress(false);
            Swal.fire({
                title: 'API Request Error',
                html: error.message,
                icon: 'error'
            });
        }
    };

    const handlereset = async () =>{
        setguipassword(loginData?.guipassword)
    };

    return (
        <div className="maincontent-outermost">
            <div className="div-container" style={{ position: "relative" }}>
                <div className="row-container" >
                    <span>Edit User Profile  <i class="fa-regular fa-pen-to-square ml-1"></i></span>
                    <table className="table table-bordered mt-4 " >
                        <thead style={{ backgroundColor: "skyblue" }}>
                            <tr>
                                <th>Field</th>
                                <th>Value</th>
                            </tr>
                        </thead>

                        <tbody className="tbody-font" >
                            <tr >
                                <td className="td-bold " style={{ verticalAlign: "middle" }}> <span style={{ fontSize: "1rem" }}>GUI User ID</span> </td>
                                <td> <input type="text" disabled className="form-control" value={loginData?.guiuserid} /> </td>
                            </tr>

                            <tr>
                                <td className="td-bold" style={{ verticalAlign: "middle" }}><span style={{ fontSize: "1rem" }}> GUI User Password </span></td>
                                <td> <input type="text" className="form-control" value={guipassword} onChange={(e) => setguipassword(e.target.value)} /> </td>
                            </tr>

                            <tr>
                                <td className="td-bold" style={{ verticalAlign: "middle" }}><span style={{ fontSize: "1rem" }}>API User ID </span></td>
                                <td> <input type="text" disabled className="form-control" value={loginData?.apiuserid} /> </td>
                            </tr>

                            <tr>
                                <td className="td-bold" style={{ verticalAlign: "middle" }}><span style={{ fontSize: "1rem" }}>API User Password</span></td>
                                <td> <input type="text" disabled className="form-control" value={loginData.apipassword} /> </td>
                            </tr>

                            <tr>
                                <td className="td-bold" style={{ verticalAlign: "middle" }}><span style={{ fontSize: "1rem" }}>User Creation Time</span></td>
                                <td> <input type="text" disabled className="form-control" value={loginData?.ctime} /> </td>
                            </tr>


                        </tbody>
                    </table>


                </div>


                <div className="row-container mt-3" >
                    <button type="submit" className="btn btn-primary" onClick={callAPI}>Save Changes</button>
                    <button type="reset" className="btn btn-danger ml-3" onClick={handlereset}>Cancel</button>
                </div>
            </div>
        </div>
    );
}